module.exports = __webpack_public_path__ + "img/sell-car600x338.edbbb02c.png";